document.addEventListener('DOMContentLoaded', () => {
  const swatchesFilter = document.querySelectorAll('.js-swatch-filter-item')

  swatchesFilter.forEach((swatch) => {
    const inputEls = swatch.querySelectorAll('input')

    if (inputEls.length === 0) {
      return
    }

    // Active tab only the last one
    const lastInput = inputEls[inputEls.length - 1]

    lastInput.setAttribute('tabindex', '0')
  })
})
